import { Select } from '@mantine/core';
import { BUILT_IN_FORMATS } from '@flow/core';

const data = BUILT_IN_FORMATS.map((f) => ({ value: f.id, label: f.name }));

/** Pick an event × rules format, e.g. "Parliamentary (CHSSA)". */
export const FormatSelect = ({ value, onChange, label = 'Event', description, testId }: {
  value: string; onChange: (id: string) => void; label?: string; description?: string; testId?: string;
}) => (
  <Select label={label} description={description} data={data} value={value} onChange={(v) => v && onChange(v)} allowDeselect={false} comboboxProps={{ zIndex: 1000 }} data-testid={testId} />
);
